import Backbone from 'backbone'

/**
 * Handles a change to a master checkbox which controls whether other
 * checkboxes are enabled and checked (e.g. clicking on Administer checks
 * and disables all other checkboxes)
 *
 * Usage:
 *
 * this.datasetToggles = new ConditionalCheckboxToggle({el: this.$('.datasets')})
 * this.datasetToggles.addToggles('modifyAllDatasets', this.$(`[name=subject1],name=subject2]`))
 * ...
 * view.onChangeModifyAll: () => this.datasetToggles.toggle('modifyAllDatasets)
 */


class ConditionalCheckboxToggle extends Backbone.View {

	initialize(options = {}) {
		this.masterToggles = {}
	}

	/**
	 * Registers a relationship between master checkbox and it's subjects
	 * that will be toggled when the master is checked/unchecked.
	 *
	 * @param {String} master `name` of Master checkbox input
	 * @param {JQuery[]} subjects Checkbox(es) toggled based on master selection
	 */
	addRelation(master, subjects) {
		this.masterToggles[master] = subjects
	}

	/**
	 * Toggles a master checkbox's subjects.
	 *
	 * @param {String} master The name of the master checkbox input
	 */
	toggle(master) {
		changeMasterCheckbox(this.$(`[name=${master}]`), this.masterToggles[master])
	}
}

/**
 * @param masterCheckbox e.g. administer
 * @param subjects e.g. all the checkboxes other than administer
 */
function changeMasterCheckbox(masterCheckbox, subjects) {
	if (masterCheckbox.prop('disabled')) {
		return
	}

	var checked = masterCheckbox.prop('checked')
	if (checked) {
		subjects
			.prop('checked', true)
			.prop('disabled', true)
	} else {
		subjects.prop('disabled', false)
	}
}

export default ConditionalCheckboxToggle
ConditionalCheckboxToggle.__filename__ = 'components/conditional-checkbox-toggle.js'
